import { commonChartOptions } from './commonChartOptions';

function toggleSeriesVisibility(legendName, chart) {
  chart.series.forEach((seriesData) => {
    seriesData.data.forEach((data) => {
      if (data.name === legendName) {
        if (data.visible) {
          data.setVisible(false);
        } else {
          data.setVisible(true);
        }
      }
    });
  });
}

function setSeriesState(legendName, chart, inactiveState = 'inactive', activeState = 'hover') {
  chart.series.forEach((seriesData) => {
    seriesData.data.forEach((data) => {
      if (data.name !== legendName) {
        data.setState(inactiveState);
      }

      if (data.name === legendName) {
        data.setState(activeState);
      }
    });
  });
}

function setSlicedState(pointId, chart, slice = false) {
  chart.series.forEach((seriesData) => {
    seriesData.points.forEach((point) => {
      if (point.id === pointId && point.percentage > 0) {
        try {
          point.slice(slice);
        } catch (e) {
          console.error(e);
        }
      }
    });
  });
}

export function addMouseOverListenersToLegends(chart) {
  if (chart && chart.series && chart.series[0]) {
    // TODO: Remove event listeners, https://api.highcharts.com/highcharts/plotOptions.series.point.events.remove
    chart.series[0].data.forEach(function handleMouseOver(point) {
      point.legendGroup.on('mouseover', function legendMouseOver(e) {
        setSeriesState(e.currentTarget.textContent, chart, 'inactive', 'select');
        setSlicedState(e.currentTarget.textContent, chart, true);
      });

      point.legendGroup.on('mouseout', function legendMouseOut(e) {
        setSeriesState(undefined, chart, 'normal', 'normal');
        setSlicedState(e.currentTarget.textContent, chart, false);
      });

      point.legendGroup.on('click', function legendMouseOut(e) {
        toggleSeriesVisibility(e.currentTarget.textContent, chart);
      });
    });
  }
}

export const PIE_LEGEND_MAX_HEIGHT = 400;

export const defaultPieChartOptions = Object.assign({}, commonChartOptions, {
  plotOptions: {
    pie: {
      point: {
        events: {
          legendItemClick: function onClickPieLegend() {
            return false;
          }
        }
      }
    },
    series: {
      states: {
        inactive: {
          animation: {
            duration: 0
          }
        },
        normal: {
          animation: {
            duration: 0
          }
        }
      }
    }
  },
  legend: {
    maxHeight: PIE_LEGEND_MAX_HEIGHT
  }
});


